export default __webpack_public_path__ + "static/media/bg_style2.f9734862.png";